// extracted by mini-css-extract-plugin
export default {"download-link":"BatchDownloadModal_download-link__7hLDf","disabled":"BatchDownloadModal_disabled__Sq6w2"};